export default __webpack_public_path__ + "static/media/banner-img.7707dc3b.jpg";